;(function (angular, _) {
  'use strict'

  angular
    .module('kilo.routes.preferences')
    .controller('CreateProductTypeController', CreateProductTypeController)
    .directive('productTypeExist', ProductTypeExistDirective)

  CreateProductTypeController.$inject = [
    // Angular
    '$uibModalInstance',

    // Resolved
    'action', 'type'

  ]

  function CreateProductTypeController (
    // Angular
    $uibModalInstance,
    // Resolved
    action, type
  ) {
    var self = this

    self.$onInit = () => {
      _.extend(self, {
        // Public Attributes
        action: action,
        type: type,
        newVat: {},

        // Public Method
        addVat: addVat,
        deleteVat: deleteVat,
        accept: accept,
        cancel: cancel
      })
    }

    function addVat () {
      self.type.vats = self.type.vats || []
      self.type.vats.unshift(self.newVat)
      self.newVat = {}
    }

    function deleteVat (vat) {
      self.type.vats = self.type.vats || []
      self.type.vats.splice(_.findIndex(function (elt) { return elt.value === vat.value }), 1)
    }

    function accept () {
      $uibModalInstance.close(self.type)
    }

    function cancel () {
      $uibModalInstance.dismiss()
    }
  }

  ProductTypeExistDirective.$inject = [
    // Angular
    '$q', '$timeout',
    // Libs
    // Managers
    'ProductTypeManager'
    // Services
    // Const
    // Resolved
  ]

  function ProductTypeExistDirective (
    // Angular
    $q, $timeout,
    // Libs
    // Managers
    ProductTypeManager
    // Services
    // Const
    // Resolved
  ) {
    return {
      require: 'ngModel',
      restrict: 'A',
      scope: {
        productTypeExist: '@',
        modelId: '='
      },
      link: (scope, element, attrs, ngModel) => {
        const field = scope.productTypeExist || 'label'
        ngModel.$asyncValidators.productTypeExist = function (modelValue, viewValue) {
          const query = ProductTypeManager.query({
            conditions: {
              ['' + field]: viewValue
            },
            limit: 1,
            select: '_id',
            count: true
          })
          if (scope.modelId) {
            query.opts.conditions._id = {
              $ne: scope.modelId
            }
          }
          return ProductTypeManager.get(query).then(({ data }) => {
            if (data > 0) {
              return $q.reject()
            }
            return true
          })
        }
      }
    }
  }
})(window.angular, window._)
